export default __webpack_public_path__ + "static/media/chainshot_alone.90c6b6ae.png";